import { fetchEB } from '@eb/http';

export const getUser = async () =>
    fetchEB('/api/v3/users/me/').then((response: any) =>
        response
            .json()
            .then((responseData: any) => Promise.resolve(responseData)),
    );

export const getUserOrders = async () =>
    fetchEB(
        '/api/v3/users/me/orders/?time_filter=current_future&expand=event,event.has_digital_content',
    ).then((response: any) =>
        response
            .json()
            .then((responseData: any) => Promise.resolve(responseData)),
    );
